<style lang="less">
.search {
  padding: 20px 22px;
  display: flex;
  box-sizing: border-box;
  position: relative;

  form {
    margin: 0;
    padding: 0;
    height: 44px;
    flex: 1;
  }
  input {
    width: 100%;
    height: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    border: none;
    outline: none;
    box-sizing: border-box;
    padding-left: 35px;
  }
  .icon,
  .clear,
  .cancle {
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #3d434d;
  }
  .cancle {
    padding-left: 10px;
  }

  .icon,
  .clear {
    position: absolute;
    padding: 0 10px;
    z-index: 10;
    img {
      display: block;
    }
  }
  .icon {
    left: 20px;
  }
  .clear {
    right: 60px;
  }
}
</style>
<template>
  <div class="search">
    <div class="icon">
      <img src="@/assets/sousuo.svg" alt />
    </div>
    <form @submit="sumit">
      <input type="text" v-model="val" :placeholder="lang.join.searching" />
    </form>
    <div class="clear"  @click="clear" v-show="val">
      <img src="@/assets/clear.svg" alt />
    </div>
    <div class="cancle" @click="back">{{ lang.join.searchBtn }}</div>
  </div>
</template>
<script>
import mapStore from "@/mixins/mapStore";
export default {
  mixins: [
    mapStore("", {
      getters: ["lang", "china"],
    }),
  ],
  data(){
    return {
      val: "",
    }
  },
  methods: {
    sumit(e){
      this.$emit("onSerach", this.val)
      e.stopPropagation();
      e.preventDefault();
      e.stopImmediatePropagation();
    },
    clear(){
      this.val = "";
      this.$emit("onSerach", null)
    },
    back(){
      this.$router.back();
    }
  }
}
</script>